import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../../admin/Constant";

export const PackageApi = createApi({
  reducerPath: "PackageApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    addPackage: builder.mutation({
      query: (data) => ({
        url: "/packages/create",
        method: "POST",
        body: data,
      }),
    }),
    allPackage: builder.query({
      query: () => ({
        url: "/packages/all",
        method: "GET",
      }),
    }),

    combinedpackage: builder.query({
      query: () => ({
        url: "/packages/combined",
        method: "GET",
      }),
    }),

    packageTypeData: builder.query({
      query: (id) => ({
        url: `packages/type/${id}`,
        method: "GET",
      }),
    }),

    getPackageDetails: builder.query({
      query: (slug) => ({
        url: `packages/view/${slug}`,
        method: "GET",
      }),
     }),

    deletePackage: builder.mutation({
      query: (id) => ({
        url: `packages/delete/${id}`,
        method: "DELETE",
      }),
    }),
    updatePackage: builder.mutation({
      query: ({ slug, data }) => ({
        url: `packages/update/${slug}`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useAllPackageQuery,
  useAddPackageMutation,
  useDeletePackageMutation,
  useGetPackageDetailsQuery,
  useCombinedpackageQuery,
  useUpdatePackageMutation,
  usePackageTypeDataQuery,
} = PackageApi;
